import { Button } from "primereact/button"
import { ProgressSpinner } from "primereact/progressspinner"
import { GiWallet } from "react-icons/gi"
import { useEffect, useRef, useState } from "react"
import { useAuth } from "../auth/AuthProvider"
import Balance from "../components/Balance"
import { FaPix } from "react-icons/fa6";
import { HeaderType } from "../components/Title"
import { MenuItem } from "../components/Menu"
import { InputNumber, InputNumberChangeEvent } from "primereact/inputnumber"
import { QRCodeCanvas } from "qrcode.react"
import axios, { AxiosError } from "axios"
import { Toast } from "primereact/toast"
import { BsQrCodeScan } from "react-icons/bs";
type Props = {
    balance: string,
    setBalance: Function
}
export { }
declare global {
    interface Window {
        lastQR: string
    }
}
export const WalletHeader = (): HeaderType => {
    return {
        title: 'Carteira',
        subtitle: `Olá ${useAuth().profile?.nome?.split(' ')[0]}`,
        icon: <GiWallet size={40} />
    }
}
export const WalletMenu = (): MenuItem => {
    return {
        icon: <GiWallet size={32} />,
        label: 'CARTEIRA'
    }
}
const enum stPix {
    Idle = 0,
    ValorInput = 1,
    AguardandoQR = 2,
    AguardandoPagamento = 3
}
const Wallet = (props: Props) => {
    const authenticator = useAuth()
    const toastRef = useRef<Toast>(null)
    const [estadoPix, setEstadoPix] = useState<stPix>(0)
    const [valorPix, setValorPix] = useState<number>(0)
    const [qr, setQR] = useState<any>('')
    const CHECK_INTERVAL = 5000;
    const timeoutRef = useRef<NodeJS.Timeout | number | null>(null)
    useEffect(() => {
        if (window.lastQR && (typeof timeoutRef.current !== 'number')) {
            setEstadoPix(stPix.AguardandoQR)
            restartPIXCheck(window.lastQR)
        }
        return () => {
            if (typeof timeoutRef.current === 'number') {
                clearInterval(timeoutRef.current)
                timeoutRef.current = null
            }
        }
    }, [])
    const restartPIXCheck = async (url: string) => {
        try {
            const response = await checkPIX(url)
            const data = response.data
            if (data.status === 'N') {
                setEstadoPix(stPix.AguardandoPagamento)
                setQR(data.qrcode)
                startPIXCheck(data.url)
            } else {
                setEstadoPix(stPix.Idle)
            }
        } catch (error: any) {
            console.log(error.message, error.toJSON())
            setEstadoPix(stPix.Idle)
            window.lastQR = ''
        }
    }
    const onClickFazerPix = () => {
        setEstadoPix(stPix.ValorInput)
    }
    const onPixValueChange = (e: InputNumberChangeEvent) => {
        setValorPix(e.value || 0)
    }
    const onClickGerarQR = () => {
        setEstadoPix(stPix.AguardandoQR)
        axios.post('https://api.eletroposto.gearspark.com.br/api/qrcode/',
            { value: valorPix },
            {
                headers: {
                    'Authorization': `Bearer ${authenticator.token}`, //${authenticator.token}
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => {
            const data = response.data
            console.log('PIX Data', data)
            setQR(data.qrcode)
            setEstadoPix(stPix.AguardandoPagamento)
            startPIXCheck(data.url)
            window.lastQR = data.url
        }).catch((error: AxiosError) => {
            console.log(error.message, error.toJSON())
            setQR('')
            setEstadoPix(stPix.ValorInput)
            toastRef.current?.show({ severity: 'error', summary: 'Erro', detail: 'Falha na geração do PIX', life: 5000 })
        })
    }
    const startPIXCheck = async (url: string) => {
        try {
            if (timeoutRef.current === -1) return
            timeoutRef.current = -1
            const response = await checkPIX(url)
            console.log('checkPIX response', response)
            if (response.data.status === 'N') {
                timeoutRef.current = setTimeout(() => { startPIXCheck(url) }, CHECK_INTERVAL)
                return
            }
            toastRef.current?.show({ severity: 'success', summary: 'Pagamento confirmado', detail: 'Recarga via PIX bem sucedida!', life: 5000 })
            resetStates()
            props.setBalance(authenticator.getBalance())
        } catch (error: any) {
            console.error(error)
            if (error.response.status === 404) {
                toastRef.current?.show({ severity: 'error', summary: 'Erro', detail: error.response.status + ': ' + error.response.statusText })
                resetStates()
            } else {
                timeoutRef.current = setTimeout(() => { startPIXCheck(url) }, CHECK_INTERVAL)
            }
        }
    }
    const copiarQR = async () => {
        if (qr && qr !== '') {
            await navigator.clipboard.writeText(qr)
            toastRef.current?.show({ severity: 'info', summary: 'QR Code copiado', detail: 'O código do QR Code foi copiado para a área de transferência.', life: 3000 })
        }
    }
    const checkPIX = async (url: string) => {
        const response = axios.get(
            url,
            {
                headers: {
                    'Authorization': `Bearer ${authenticator.token}`,
                    'Content-Type': 'application/json'
                }
            }
        )
        return response
    }
    const resetStates = () => {
        setEstadoPix(stPix.Idle)
        setValorPix(0)
        setQR('')
        if (typeof timeoutRef.current === 'number') {
            clearTimeout(timeoutRef.current)
            timeoutRef.current = null
        }
    }
    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Toast ref={toastRef} position='center'></Toast>
            <Balance balance={props.balance} />
            {estadoPix === stPix.Idle &&
                // <div style={{ marginTop: 18, marginBottom: 18, fontSize: 20, color: 'gray' }}>Recarregue sua carteira para iniciar uma sessão de carregamento</div>}
                <Button onClick={onClickFazerPix} disabled={estadoPix !== stPix.Idle} severity={estadoPix !== stPix.Idle ? 'secondary' : undefined}>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                        <FaPix size={32} />
                        <div style={{ fontFamily: 'Verdana', fontSize: 24, marginLeft: 10 }}>FAZER PIX</div>
                    </div>
                </Button>
            }
            {(estadoPix === stPix.ValorInput || estadoPix === stPix.AguardandoQR || estadoPix === stPix.AguardandoPagamento) &&
                <div style={{}}>
                    <div>Valor <FaPix size={16} /></div>
                    <InputNumber style={{ marginTop: -4, marginBottom: 5, paddingTop: 5, paddingBottom: 5, borderRadius: 20, width: '100%' }} onChange={onPixValueChange} mode='currency' currency='BRL' locale='pt-BR' min={0} value={valorPix} disabled={estadoPix !== stPix.ValorInput} />
                </div>
            }
            {estadoPix === stPix.ValorInput && <Button style={{ display: 'flex', justifyContent: 'center' }} disabled={valorPix <= 0 || estadoPix !== stPix.ValorInput} onClick={onClickGerarQR}>Gerar QR<BsQrCodeScan style={{ marginLeft: 5 }} /></Button>}
            {estadoPix === stPix.AguardandoQR && <ProgressSpinner />}
            {estadoPix === stPix.AguardandoPagamento &&
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <QRCodeCanvas size={256} value={qr}></QRCodeCanvas>
                    <div style={{ width: 256, lineBreak: 'anywhere', fontSize: 8 }} onClick={copiarQR}>{qr}</div>
                    <div style={{ display: 'flex', alignItems: 'center', margin: 'auto', marginTop: '1rem' }}>Aguardando confimação do pagamento <ProgressSpinner style={{ width: '20px', height: '20px', marginLeft: 10 }} strokeWidth='5' animationDuration=".5s" /></div>
                </div>
            }
        </div>
    )
}
export default Wallet;